const GoldUpdateLogReportTypes = {
	/************* GOLD UPDATE LOG REPORT START *********** */
	GET_GOLD_UPDATE_LOG_REPORT_START: 'get_gold_update_log_report_start',
	GET_GOLD_UPDATE_LOG_REPORT_SUCCESS: 'get_gold__report_details_success',
	GET_GOLD_UPDATE_LOG_REPORT_FAILURE: 'get_gold__report_details_failure',
	GET_GOLD_UPDATE_LOG_REPORT_RESPONSE_RESET: 'get_gold__report_details_response_reset',
	GET_GOLD_UPDATE_LOG_REPORT_RESPONSE_CHANGED: 'get_gold__report_details_response_changed',
	/************* GOLD UPDATE LOG REPORT END *********** */
};
export default GoldUpdateLogReportTypes;
